import {css, Theme} from "@emotion/react";

import {flex, mb, w100} from "@pg-design/helpers-css";
import {InputRange, IRange} from "@pg-design/inputs-module";
import {form, IFormProps} from "@pg-mono/form";
import {Round} from "@pg-mono/formik-utils";

import {errorMessages, hasAreaValidationError} from "../../real_estate/utils/has_area_validation_error";
import {SearchFilterLabel} from "../../search/components/filters/SearchFilterLabel";
import {getAreaFilterLimitedValues} from "../../search/utils/get_area_filter_proper_value";
import {IPropertyConfiguratorSearchFiltersFormValues} from "../reducers/property_configurator_reducer";

interface IProps extends IFormProps<IPropertyConfiguratorSearchFiltersFormValues> {}

const AreaFilterC = (props: IProps) => {
    const areaProps = props.getFieldProps("area");

    const errorMessage = hasAreaValidationError(areaProps.value) ? errorMessages.area : undefined;
    const limitedAreaValues = getAreaFilterLimitedValues(areaProps.value);

    return (
        <div css={[inputContainer, areaInput]}>
            <SearchFilterLabel label="Metraż (m²)" htmlFor="area_lower" />
            <InputRange
                {...props}
                {...areaProps}
                hasDashSeparator
                roundToMultiplicationOf={Round.AREA}
                error={errorMessage}
                value={limitedAreaValues}
                onChange={(name, value) => {
                    areaProps.onChange(name, value as IRange<string>);
                }}
            />
        </div>
    );
};

export const AreaFilter = form<IPropertyConfiguratorSearchFiltersFormValues, IProps>(AreaFilterC);

const areaInput = css`
    width: 100%;

    > div {
        ${w100};
    }

    > div *:not(span):not(input) {
        ${w100};
    }
`;

const inputContainer = (theme: Theme) => css`
    ${flex("flex-start")};
    flex-direction: column;

    > label > p {
        ${mb(1)};
        color: ${theme.colors.gray[700]};
    }
`;
import {css, Theme} from "@emotion/react";

import {flex, mb, w100} from "@pg-design/helpers-css";
import {InputRange, IRange} from "@pg-design/inputs-module";
import {form, IFormProps} from "@pg-mono/form";
import {Round} from "@pg-mono/formik-utils";

import {errorMessages, hasAreaValidationError} from "../../real_estate/utils/has_area_validation_error";
import {SearchFilterLabel} from "../../search/components/filters/SearchFilterLabel";
import {getAreaFilterLimitedValues} from "../../search/utils/get_area_filter_proper_value";
import {IPropertyConfiguratorSearchFiltersFormValues} from "../reducers/property_configurator_reducer";

interface IProps extends IFormProps<IPropertyConfiguratorSearchFiltersFormValues> {}

const AreaFilterC = (props: IProps) => {
    const areaProps = props.getFieldProps("area");

    const errorMessage = hasAreaValidationError(areaProps.value) ? errorMessages.area : undefined;
    const limitedAreaValues = getAreaFilterLimitedValues(areaProps.value);

    return (
        <div css={[inputContainer, areaInput]}>
            <SearchFilterLabel label="Metraż (m²)" htmlFor="area_lower" />
            <InputRange
                {...props}
                {...areaProps}
                hasDashSeparator
                roundToMultiplicationOf={Round.AREA}
                error={errorMessage}
                value={limitedAreaValues}
                onChange={(name, value) => {
                    areaProps.onChange(name, value as IRange<string>);
                }}
            />
        </div>
    );
};

export const AreaFilter = form<IPropertyConfiguratorSearchFiltersFormValues, IProps>(AreaFilterC);

const areaInput = css`
    width: 100%;

    > div {
        ${w100};
    }

    > div *:not(span):not(input) {
        ${w100};
    }
`;

const inputContainer = (theme: Theme) => css`
    ${flex("flex-start")};
    flex-direction: column;

    > label > p {
        ${mb(1)};
        color: ${theme.colors.gray[700]};
    }
`;
